import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss'
})
export class ErrorDialogComponent {

  errorList = []
  isError = true;
  isWarning = false;
  isWithRestricciones = false;
  message: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { error, isError, message, isWarning, isWithRestricciones },
    public dialogRef: MatDialogRef<ErrorDialogComponent>) {
    if (typeof data.error !== 'string') {
      this.errorList = data.error
    }

    this.isError = data.isError;
    this.isWarning = data.isWarning;
    this.isWithRestricciones = data.isWithRestricciones;
    this.message = data.message || '';
  }

  ngOnInit() { }

  closeDialog() {
    this.dialogRef.close({ event: 2 });
  }

  save() {

    this.dialogRef.close({ event: 1 });
  }

}